import Item from './item';

(Item as any).compName = 'PageNavItem';
export default Item;